import React, { useState, useEffect } from 'react';
import { HuePicker } from 'react-color';
import { Link, useLocation } from 'react-router-dom';

import'../Game.css'


// Config

// Components
import Header from './Header';
import Body from './Body';
import Knoppie from './Knoppie';
import Spacer from './Spacer';

// Hook

// Image


const Home = () => {

  

  localStorage.removeItem('vrae')
  const colorTop = localStorage.getItem('colorone')
  const colorBottom = localStorage.getItem('colortwo')



  const [isButton1Clicked, setIsButton1Clicked] = useState( false );
  const [isButton2Clicked, setIsButton2Clicked] = useState( false );
  const [isButton3Clicked, setIsButton3Clicked] = useState( false );
  const [isButton4Clicked, setIsButton4Clicked] = useState( false );
  const [isButton5Clicked, setIsButton5Clicked] = useState( false );
  const [isButton6Clicked, setIsButton6Clicked] = useState( false );
  const [isButton7Clicked, setIsButton7Clicked] = useState( false );
  const [isButton8Clicked, setIsButton8Clicked] = useState( false );
  const [isButton9Clicked, setIsButton9Clicked] = useState( false );
  const [isButton10Clicked, setIsButton10Clicked] = useState( false );
  const [isButton11Clicked, setIsButton11Clicked] = useState( false );
  const [isButton12Clicked, setIsButton12Clicked] = useState( false );
  const [playable, setplayable] = useState(false)

  const [colorone, setcolorone] = useState(colorTop?colorTop:"green")
  const [colortwo,setcolortwo] = useState(colorBottom?colorBottom:"purple")
  
  const handleButton1Clicked = () => setIsButton1Clicked(prev => !prev)
  const handleButton2Clicked = () => setIsButton2Clicked(prev => !prev);
  const handleButton3Clicked = () => setIsButton3Clicked(prev => !prev);
  const handleButton4Clicked = () => setIsButton4Clicked(prev => !prev);
  const handleButton5Clicked = () => setIsButton5Clicked(prev => !prev);
  const handleButton6Clicked = () => setIsButton6Clicked(prev => !prev);
  const handleButton7Clicked = () => setIsButton7Clicked(prev => !prev);
  const handleButton8Clicked = () => setIsButton8Clicked(prev => !prev);
  const handleButton9Clicked = () => setIsButton9Clicked(prev => !prev);
  const handleButton10Clicked = () => setIsButton10Clicked(prev => !prev);
  const handleButton11Clicked = () => setIsButton11Clicked(prev => !prev);
  const handleButton12Clicked = () => setIsButton12Clicked(prev => !prev);

  
  
  
  const tafels = []

  useEffect(()=>{

    if(isButton1Clicked||isButton2Clicked||isButton3Clicked||isButton4Clicked||
      isButton5Clicked||isButton6Clicked||isButton7Clicked||isButton8Clicked||
      isButton9Clicked||isButton10Clicked||isButton11Clicked||isButton12Clicked){
        setplayable(true)
      }else{
        setplayable(false)
      }

  },[isButton1Clicked,isButton2Clicked,isButton3Clicked,isButton4Clicked,
  isButton5Clicked,isButton6Clicked,isButton7Clicked,isButton8Clicked,
  isButton9Clicked,isButton10Clicked,isButton11Clicked,isButton12Clicked])

  const checkChosen = ()=> {


      if (isButton1Clicked){tafels.push(1)}
      if (isButton2Clicked){tafels.push(2)}
      if (isButton3Clicked){tafels.push(3)}
      if (isButton4Clicked){tafels.push(4)}
      if (isButton5Clicked){tafels.push(5)}
      if (isButton6Clicked){tafels.push(6)}
      if (isButton7Clicked){tafels.push(7)}
      if (isButton8Clicked){tafels.push(8)}
      if (isButton9Clicked){tafels.push(9)}
      if (isButton10Clicked){tafels.push(10)}
      if (isButton11Clicked){tafels.push(11)}
      if (isButton12Clicked){tafels.push(12)}

           
  }  


  return (
    <>
      <Header colorone={colorone} colortwo={colortwo}/>
     <Body header="Kies die tafels om te oefen">
        <div key={1}>
        <Knoppie
        
          switchOn = {isButton1Clicked}
          clickable={false}
          callback = {handleButton1Clicked}
          nommer={1 + ' x tafel'}
          colorone={colorone}
          colortwo={colortwo}
        />

        </div>

        <div key={2}>

        <Knoppie
        
        switchOn = {isButton2Clicked}
        clickable={false}
        callback = {handleButton2Clicked}
        nommer={2 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />
        </div>
        <div key={3}>
        <Knoppie
        
        switchOn = {isButton3Clicked}
        clickable={false}
        callback = {handleButton3Clicked}
        nommer={3 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />

        </div>
        <div key={4}>
          <Knoppie
          
          switchOn = {isButton4Clicked}
          clickable={false}
          callback = {handleButton4Clicked}
          nommer={4 + ' x tafel'}
          colorone={colorone}
          colortwo={colortwo}
          />
          
        </div>
        <div key={5}>
          <Knoppie
          
          switchOn = {isButton5Clicked}
          clickable={false}
          callback = {handleButton5Clicked}
          nommer={5 + ' x tafel'}
          colorone={colorone}
          colortwo={colortwo}
          />
          
        </div>
        <div key={6}>
          
          <Knoppie
          
          switchOn = {isButton6Clicked}
          clickable={false}
          callback = {handleButton6Clicked}
          nommer={6 + ' x tafel'}
          colorone={colorone}
          colortwo={colortwo}
          />
        </div>
        <div key={7}>
          <Knoppie
          
          switchOn = {isButton7Clicked}
          clickable={false}
          callback = {handleButton7Clicked}
          nommer={7 + ' x tafel'}
          colorone={colorone}
          colortwo={colortwo}
          />
          
        </div>
        <div key={8}>
        <Knoppie
        
        switchOn = {isButton8Clicked}
        clickable={false}
        callback = {handleButton8Clicked}
        nommer={8 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />
          
        </div>
        <div key={9}>
        <Knoppie
        
        switchOn = {isButton9Clicked}
        clickable={false}
        callback = {handleButton9Clicked}
        nommer={9 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />
          
        </div>
        <div key={10}>
        <Knoppie
        
        switchOn = {isButton10Clicked}
        clickable={false}
        callback = {handleButton10Clicked}
        nommer={10 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />
          
        </div>
        <div  key={11}>
        <Knoppie
       
        switchOn = {isButton11Clicked}
        clickable={false}
        callback = {handleButton11Clicked}
        nommer={11 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />
          
        </div>
        <div key={12}>
          
        <Knoppie
        
        switchOn = {isButton12Clicked}
        clickable={false}
        callback = {handleButton12Clicked}
        nommer={12 + ' x tafel'}
        colorone={colorone}
          colortwo={colortwo}
        />
        </div>
      
     </Body>

      <div className='Colorptions'>
        Verander die boonste kleur
     <HuePicker
     
      color={colorone}
      onChangeComplete={(colorone) => {
        setcolorone(colorone.hex)
        localStorage.setItem('colorone',colorone.hex)
      }}
    >
    </HuePicker>
    </div>
    <div className='Colorptions'>
      Verander die onderste kleur
    <HuePicker
      color={colortwo}
      onChangeComplete={(colortwo) => {
        setcolortwo(colortwo.hex)
        localStorage.setItem('colortwo',colortwo.hex)
      }}
    >
    </HuePicker>
    

    </div>
    {/* <SliderPicker
      color={colorone}
      onChangeComplete={(colorone) => {setcolorone(colorone.hex)}}
    >
        <div>Verander die Boonste kleur</div>

    </SliderPicker>
    <SliderPicker
      color={colortwo}
      onChangeComplete={(colortwo) => {setcolortwo(colortwo.hex)}}
    >
        <div>Verander die Boonste kleur</div>

    </SliderPicker> */}


     <Spacer/>

         
          <Knoppie 
          onclick={checkChosen()}
          clickable={playable} 
          tafels={tafels}
          message={"(Jy het nog geen tafels gekies nie.)"} 
          nommer = {"Begin Toets"}
          colorone={colorone}
          colortwo={colortwo}> 
          </Knoppie>

     
   
   
       

    </>
  );
};

export default Home;
